// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3arDo","title":"styles_title__3G74l"};